export const SYMBOLS = {
  BOOM: ["Boom 1000", "Boom 900", "Boom 600", "Boom 500", "BOOM300N"],
  CRASH: ["Crash 1000", "Crash 900", "Crash 600", "Crash 500", "CRASH300N"],
};

export const TIMEFRAMES = [
  { label: "1m", value: 60 },
  { label: "3m", value: 180 },
  { label: "5m", value: 300 },
  { label: "15m", value: 900 },
  { label: "30m", value: 1800 },
  { label: "1h", value: 3600 },
  { label: "4h", value: 14400 },
];

export const HTF_TIMEFRAMES = [300, 900, 1800];

export function detectMarketFromSymbol(symbol) {
  return /crash/i.test(symbol || "") ? "CRASH" : "BOOM";
}

export function formatTimeframeLabel(timeframe) {
  const match = TIMEFRAMES.find((item) => item.value === Number(timeframe));

  return match?.label || `${Math.max(1, Math.round(Number(timeframe || 0) / 60))}m`;
}
